import React from 'react'
import FormReport from "../../../../../../components/pages/FormReport";
import { useFetch } from '../../../../../../hooks/useFetch';

export default () => { // eslint-disable-line

    return (
        <FormReport
            title={'Import Document Reports'}
            repType={'daily'}
            repUrl={'document_report'}
            url={"/api/v1/report_import"}
            FetchComponent={useFetch}
        />
    )
}